import type { LocaleCode } from '../stores/localeStore';
import { localeMessages } from './locales';
import type { MessageKey, TranslateParams } from './types';

function readPath(obj: unknown, key: string): string | undefined {
  const value = key.split('.').reduce<unknown>((current, part) => {
    if (current && typeof current === 'object' && part in current) {
      return (current as Record<string, unknown>)[part];
    }
    return undefined;
  }, obj);

  return typeof value === 'string' ? value : undefined;
}

function applyParams(template: string, params?: TranslateParams): string {
  if (!params) return template;
  return template.replace(/\{(\w+)\}/g, (match, name: string) => {
    const value = params[name];
    return value === undefined ? match : String(value);
  });
}

export function translate(
  locale: LocaleCode,
  key: MessageKey,
  params?: TranslateParams
): string {
  const template =
    readPath(localeMessages[locale], key) ??
    readPath(localeMessages.en, key) ??
    key;
  return applyParams(template, params);
}
